"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (tlSelectConfigRegistry, banqueSelectConfig, allBanqueSelectConfig) {
  tlSelectConfigRegistry.registerConfig("banque", banqueSelectConfig);
  tlSelectConfigRegistry.registerConfig("all-banque", allBanqueSelectConfig);
});
ngModule.factory("banqueSearchMatcher", function (stringUtils) {
  return function (text, option) {
    return stringUtils.containsIgnoringCaseAndAccents(option.libelleJuridique, text) || stringUtils.containsIgnoringCaseAndAccents(option.libelleCourtUsuel, text) || stringUtils.containsIgnoringCaseAndAccents(option.groupLabel, text);
  };
});
ngModule.factory("banqueSelectConfig", function (banqueSearchMatcher, banqueSelectPopin) {
  return {
    idAttribute: "id",
    optionTemplate: require("./banqueOption.html"),
    optionsFilter: function optionsFilter(option) {
      return option.$inCompte;
    },
    sort: function sort(a, b) {
      var attrA = a.libelleCourtUsuel;
      var attrB = b.libelleCourtUsuel;
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    },
    expandButton: {
      label: "Toutes les banques",
      handler: function handler(ctrl) {
        ctrl.closeDropdown();
        banqueSelectPopin.open().then(function (selected) {
          ctrl.setSelectedOptionById(selected.id);
        });
      }
    },
    allowEmptySelect: false,
    matcher: banqueSearchMatcher
  };
});
ngModule.factory("allBanqueSelectConfig", function (banqueSearchMatcher) {
  return {
    idAttribute: "id",
    optionTemplate: require("./banqueOption.html"),
    groupBy: "groupLabel",
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    matcher: banqueSearchMatcher,
    allowEmptySelect: false
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/banques/banqueSelectConfig.js
// module id = 2991
// module chunks = 13